import React from 'react';

export default function SectionWrapper({ children }) {
	return <div className='sectionWrapper'>{children}</div>;
}
